import { ReactComponent as UploadIcon } from 'assets/icons/upload_purple.svg';
import styles from './AIDrivenSearchUploadClickUpload.module.scss';

/**
 * @summary AIDrivenSearchUploadClickUpload - Empty state prompt for file upload
 */
export const AIDrivenSearchUploadClickUpload = () => {
  return (
    <div
      className={`custom-drag-upload-static__upload-area ${styles.container}`}
    >
      <UploadIcon className={styles.icon} />
      <div className={styles.texts}>
        <span className={styles['first-span']}>
          <span>Click to upload</span> or drag and drop
        </span>
        <span className={styles['second-span']}>
          {fileAccepts} (max file size: {fileLimit}MB)
        </span>
      </div>
    </div>
  );
};

const fileAccepts = '.xlsx, .xls, .xlsm';
const fileLimit = 100;
